import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PlusCircle, ArrowRight, Inbox } from "lucide-react";
import api from "@/lib/api";
import StatusBadge from "@/components/StatusBadge";
import { useAuth } from "@/context/AuthContext";

export default function ClientRequests() {
  const { user } = useAuth();
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/requests").then((r) => setRequests(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-5xl">
      <div className="flex items-end justify-between mb-8">
        <div>
          <p className="text-coral text-xs font-bold uppercase tracking-widest mb-2">Client Portal</p>
          <h1 className="font-serif text-4xl font-bold tracking-tight">Hello, {user?.name?.split(" ")[0]}.</h1>
          <p className="text-zinc-500 mt-2">Track your sourcing requests and quotes.</p>
        </div>
        <Link to="/portal/new" className="bg-coral hover:bg-coral-hover text-white font-semibold px-5 py-3 rounded-sm transition flex items-center gap-2" data-testid="new-request-btn">
          <PlusCircle size={18} /> New Request
        </Link>
      </div>

      {loading ? (
        <div className="text-zinc-400 py-20 text-center">Loading...</div>
      ) : requests.length === 0 ? (
        <div className="bg-white border border-zinc-200 rounded-sm p-16 text-center" data-testid="empty-requests">
          <Inbox className="mx-auto text-zinc-300 mb-4" size={48} strokeWidth={1.2} />
          <h3 className="font-serif text-xl font-bold">No requests yet</h3>
          <p className="text-zinc-500 mt-2 mb-6">Submit your first RFQ and our team will get to work.</p>
          <Link to="/portal/new" className="bg-coral hover:bg-coral-hover text-white font-semibold px-6 py-3 rounded-sm transition inline-flex items-center gap-2">
            Submit a Request <ArrowRight size={17} />
          </Link>
        </div>
      ) : (
        <div className="bg-white border border-zinc-200 rounded-sm overflow-hidden" data-testid="requests-table">
          <table className="w-full text-left">
            <thead>
              <tr className="border-b-2 border-zinc-900">
                <th className="py-3 px-5 text-xs font-bold uppercase tracking-wider">Request</th>
                <th className="py-3 px-5 text-xs font-bold uppercase tracking-wider">Quantity</th>
                <th className="py-3 px-5 text-xs font-bold uppercase tracking-wider">Status</th>
                <th className="py-3 px-5 text-xs font-bold uppercase tracking-wider"></th>
              </tr>
            </thead>
            <tbody>
              {requests.map((r) => (
                <tr key={r.id} className="border-b border-zinc-100 hover:bg-zinc-50 transition" data-testid={`request-row-${r.id}`}>
                  <td className="py-4 px-5">
                    <div className="font-semibold">{r.title}</div>
                    <div className="text-xs text-zinc-500">{r.category}</div>
                  </td>
                  <td className="py-4 px-5 text-sm text-zinc-600">{r.quantity}</td>
                  <td className="py-4 px-5"><StatusBadge status={r.status} /></td>
                  <td className="py-4 px-5 text-right">
                    <Link to={`/portal/requests/${r.id}`} className="text-coral font-semibold text-sm inline-flex items-center gap-1 hover:gap-2 transition-all" data-testid={`view-request-${r.id}`}>
                      View <ArrowRight size={15} />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
